import { CardMedia, Grid, styled } from "@mui/material";
import { useEffect } from "react";
import { useAppDispatch } from "../app/hooks";
import { setIsAuthenticated } from "../features/auth/auth.slice";
import { useLocation, useNavigate } from "react-router-dom";
import allInOneImage from "../resources/images/home/all-in-one.jpg";
import Footer from "../components/Footer";
import Hero from "../components/hero";
import Features from "./Features";
import Pricing from "./Pricing";
import theme from "../app/app-theme";

// const CheckFeatureButton = styled(Button)(({ theme }) => ({
//   justifyContent: 'space-around',
//   border: ` ${theme.palette.primary.main} 1px solid`,
//   borderRadius: '40px',
//   fontSize: 'large',
//   backgroundColor: ` ${theme.palette.primary.main} !important`,
//   color: `${theme.palette.secondary.light} !important`,
//   padding: '22px 48px',
//   '& .MuiTypography-root': {
//     textAlign: 'center'
//   },
//   '&:hover': {
//     color: `${theme.palette.primary.main} !important`,
//     background: `${theme.palette.secondary.light} !important`
//   }
// }));

// const CheckPlanButton = styled(Button)(({ theme }) => ({
//   justifyContent: 'space-around',
//   border: ` ${theme.palette.primary.main} 1px solid`,
//   borderRadius: '40px',
//   fontSize: 'large',
//   color: `${theme.palette.primary.dark} !important`,
//   background: `${theme.palette.secondary.light} !important`,
//   padding: '22px 48px',
//   '& .MuiTypography-root': {
//     textAlign: 'center'
//   },
//   '&:hover': {
//     color: `${theme.palette.secondary.light} !important`,
//     background: `${theme.palette.primary.dark}!important`,
//     border: `1px solid !important`
//   }
// }));

const RootDiv = styled('div')(({ theme }) => ({
  backgroundColor: `${theme.palette.secondary.light}`,
}));

const SideBySideRow = styled(Grid)(({ theme }) => ({
  marginTop: '12px',
  [theme.breakpoints.down('sm')]: {
    marginTop: '2rem',
    marginBottom: '2rem',
  }
}));

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      dispatch(setIsAuthenticated(true));
      navigate('/dashboard');
    } else {
      dispatch(setIsAuthenticated(false));
    }
  })

  // If we navigated here with a target section (Nav put it in location.state.scrollTo),
  // scroll to it after mount. scroll-margin-top on sections avoids the fixed AppBar overlap.
  useEffect(() => {
    const state = (location.state as any) ?? {};
    const targetId = state.scrollTo as string | undefined;
    if (targetId) {
      // small delay to ensure the DOM is ready, then scroll into view
      setTimeout(() => {
        const el = document.getElementById(targetId);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        // clear the state so future navigations don't re-trigger
        navigate(location.pathname, { replace: true, state: {} });
      }, 60);
    }
  }, [location, navigate]);

  return (
    <main>
      <section id="home">
        <RootDiv>
          <div>
            <Hero />
          </div>

          {/* <Grid container direction="row" justifyContent="center" alignItems="center" style={{ backgroundColor: "teal" }}>
            <BenefitCard
              title="Retain your members"
              description="Don't let you members quit. Keep them coming with frequent notifications"
              image={notificationImage}
            />
            <BenefitCard
              title="Track your growth"
              description="Follow how your fitness center perform over a period of time"
              image={growthImage}
            />
            <BenefitCard
              title="Make informed decisions"
              description="Power-up your decision making and grow your business"
              image={decisionMakingImage}
            />
            <BenefitCard
              title="Track your members"
              description="Have better understaing about your members and their activities"
              image={memberDataImage}
            />

          </Grid> */}

          <SideBySideRow container direction="row" justifyContent="center" alignItems="center" >
            <Grid size={{ md: 6 }}>
              <div style={{ marginRight: "4px", marginLeft: "4px", textAlign: "center", color: `${theme.palette.primary.main}` }}>
                <h1>All-in-one feature-rich application</h1>
                <h3>Enjoy vast range of features tailor-made for managing fitness centers</h3>
              </div>
              {/* <div style={{ marginTop: '2rem', textAlign: "center" }}>
                <CheckFeatureButton onClick={() => navigate("/features")}>Check all features</CheckFeatureButton>
              </div> */}
            </Grid>
            <Grid size={{ lg: 4, md: 4 }}>
              <div>
                <CardMedia
                  component="img"
                  image={allInOneImage}
                  height="50%%"
                />
              </div>
            </Grid>
          </SideBySideRow>
          {/* <Grid container direction="row" justifyContent="center" alignItems="center" sx={{ backgroundColor: "navy" }}>
            <Grid size={{ xs: 12 }}>
              <div style={{ marginRight: "4px", marginLeft: "4px", textAlign: "center", color: `${theme.palette.secondary.contrastText}` }}>
                <h2>Select the best suited plan for your business</h2>
              </div>
              <div style={{ marginBottom: '1rem', textAlign: "center" }}>
                <CheckPlanButton variant="contained" onClick={() => navigate("/pricing")}>Check Pricing Plans</CheckPlanButton>
              </div>
            </Grid>
          </Grid> */}
          {/* <Footer /> */}
        </RootDiv>
      </section>
      <section id="features" style={{ scrollMarginTop: '64px' }}>
        <Features />
      </section>
      <section id="pricing" style={{ scrollMarginTop: '64px' }}>
        <Pricing />
      </section>
      <section id="footer">
        <Footer />
      </section>
    </main>
  )
};

export default Home;